import { PrivateConfig } from '../private_config'

export const environment = {
  production: true,
  firebase: PrivateConfig.firebase
};